export const userListHeaders = [{
  text: 'Benutzername',
  value: 'username',
},
{
  text: 'E-Mail-Adresse',
  value: 'email',
},
{
  text: 'Vorname',
  value: 'firstname',
},
{
  text: 'Nachname',
  value: 'surname',
},
{
  text: 'Gelöscht',
  value: 'isDelete',
},
{
  text: 'Aktionen',
  value: '',
  sortable: false,
},
];
